import { webstore } from "../vue/helpers/auth-helpers";
import { getStoredUtm } from "./utmTracker";

const UTM_FIELD_ID = "36644367861149";
const ZENDESK_SUPPORT_ROUTES = new Set([
  "faq",
  "help-center",
  "unsubscribe",
]);

export function updateZendeskVisibility(route = window.location.pathname) {
  if (typeof window.zE !== "function") return;

  const normalizedRoute = route.replace(/^\/+|\/+$/g, "");
  const isProfileActive = document.body.classList.contains(
    "zendesk-profile-active"
  );
  const command =
    ZENDESK_SUPPORT_ROUTES.has(normalizedRoute) || isProfileActive
      ? "show"
      : "hide";

  window.zE("messenger", command);
}

async function initUserMetadata() {
  const host = window.location.hostname;
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const msisdn = webstore.getProperty("msisdn");

  const fields = [
    { id: "32029301330589", value: timezone },
    { id: "31943203621021", value: host },
    { id: "5716867531933", value: msisdn },
  ];

  const utm = getStoredUtm();
  const utmParts = [
    utm && utm.utm_source   ? 'source='   + utm.utm_source   : null,
    utm && utm.utm_medium   ? 'medium='   + utm.utm_medium   : null,
    utm && utm.utm_campaign ? 'campaign=' + utm.utm_campaign : null,
    utm && utm.utm_content  ? 'content='  + utm.utm_content  : null,
  ].filter(Boolean).join('; ');
  if (utmParts) fields.push({ id: UTM_FIELD_ID, value: utmParts });

  return fields.filter((f) => f.value != null && f.value !== "");
}

async function initZendeskMessaging() {
  updateZendeskVisibility();

  zE("messenger:on", "open", async function () {
    // recomputed on every open (not once at widget load) so it reflects
    // UTM/auth state that may only settle after the initial page load
    const metaFields = await initUserMetadata();
    zE("messenger:set", "conversationFields", metaFields);
  });

  // conversationFields only actually land on the conversation the next time
  // a message is sent, not when messenger:set is called - recompute here too
  // in case state changed between opening the widget and sending
  zE("messenger:set", "beforeMessageSent", async function (message) {
    const metaFields = await initUserMetadata();
    zE("messenger:set", "conversationFields", metaFields);
    return message;
  });
}

window.initZendeskMessaging = initZendeskMessaging;
